module.exports = __webpack_public_path__ + "@/assets/img/dashboard-due-alert-2.6cee4259.png";